export default __webpack_public_path__ + "static/media/shopper.6dd6c151.png";